/**
 * @nelo/signup-lib - A library for implementing Nelo's signup flow
 *
 * This library provides hooks and utilities for implementing a signup flow
 * that integrates with Nelo's API.
 *
 * The main exports are:
 * - SignupProvider: Context provider that sets up the API client and shared state
 * - useSignup: A consolidated hook that provides all signup functionality
 *
 * This library maintains a single source of truth for form data and provides
 * a unified interface for form state management and API interactions.
 */
// Context and provider
import { SignupProvider, } from "./SignupContext";
// Hooks
import { useSignup } from "./hooks/useSignup";
import { 
// Field hooks
usePhoneNumber, useEmail, useVerificationCode, useCurp, useCurpDetails, useOccupation, useIncome, useAddress, usePin, useReferralData, 
// API hooks
useSendVerificationCode, useSubmitVerificationCode, useValidateCurp, useGenerateCurp, useSubmitSignup, } from "./hooks";
// Import translation hooks and utilities
import i18n from "./utils/i18n";
// Validation
import { phoneNumberSchema, emailSchema, verificationCodeSchema, } from "./utils/ValidationSchemas";
// Error handling
import { ApiError, ValidationError, NetworkError, UserAlreadyExistsError, InvalidStateError, } from "./utils/Errors";
// Re-export the main components and hooks
export { 
// Context and provider
SignupProvider, 
// Main hook
useSignup, 
// Field hooks
usePhoneNumber, useEmail, useVerificationCode, useCurp, useCurpDetails, useOccupation, useIncome, useAddress, usePin, useReferralData, 
// API hooks
useSendVerificationCode, useSubmitVerificationCode, useValidateCurp, useGenerateCurp, useSubmitSignup, 
// Form validation state interface
// Validation schemas
phoneNumberSchema, emailSchema, verificationCodeSchema, 
// Error classes
ApiError, ValidationError, NetworkError, UserAlreadyExistsError, InvalidStateError, 
// Translation utilities
i18n, };
